import { authenticatedPost } from '../../../../../../api/request';

export default async function createAvailability(idDoctorUser, availabilityBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando una nueva cita.');
    const url = `/doctor-profile-management/availability/${idDoctorUser}`;
    return await authenticatedPost(url, onFail, availabilityBody);
}
